import axios from 'axios';

// Set up Axios Instance with base address from environment variable
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  withCredentials: true,
});

export default api;
